import { appInstallTopBannerState, getAppInstallTopBannerState, hideBanner } from '@/recoil/atoms/cuj/index';
import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';

const useAppInstallTopBanner = () => {
  const { isVisible } = useRecoilValue(appInstallTopBannerState);

  useEffect(() => {
    getAppInstallTopBannerState();
  }, []);

  return {
    isVisible,
    hideBanner,
  };
};

export default useAppInstallTopBanner;
